<template>
  <div>
    <div style="margin-top: 10px">
      <el-button :type="buttonActive === 'all'? 'info' : ''"
                 @click="changeContent('all')"
                 size="mini" round>
        全部
      </el-button>
      <el-button :type="buttonActive === 'finish'? 'info' : ''"
                 @click="changeContent('finish')"
                 size="mini" round>
        完成
      </el-button>
      <el-button style="float: right"
                 type="warning"
                 size="small "
                 title="我有疑问"
                 round
                 @click="toAsk"
                 v-if="this.$store.state.userInfo">
        我有疑问
      </el-button>
      <el-button style="float: right"
                 type="primary"
                 size="small "
                 title="提问请登录"
                 round
                 @click="toLogin"
                 v-else>
        提问请登录
      </el-button>
    </div>
    <!--问答内容-->
    <div style="margin-top: 20px">
      <div v-if="qaArray.length === 0" style="margin:40px 0;text-align: center">
        <img src="@/assets/img/none.png" width="240" height="240" alt="">
      </div>
      <!--用户评价-->
      <el-card class="box-card" v-for="(qa,index) in qaArray" :key="qa.Id">
        <div class="icon-qa" :class="qa.status === 'A'?'icon-finish':''"></div>
        <div class="qa">
          <div style="width: 70px; float: left">
            <el-avatar :size="50" @error="errorHandler">
              <img :src="qa.headImg" alt=""/>
            </el-avatar>
          </div>
          <div class="qa-content" >
            <div class="title">{{qa.username}}</div>
            <div style="margin-top: 8px">
              <span style="margin-right: 5px">
                <el-button type="warning" circle size="mini">问</el-button>
              </span>
              <span class="content"> {{qa.question}}</span>
            </div>
            <div style="margin-top: 8px">
              <span style="margin-right: 5px">
                <el-button type="success" circle size="mini">答</el-button>
              </span>
              <span class="content" v-if="qa.status === 'A'">
                {{qa.answer}}
              </span>
              <span class="content" v-else>
                暂无回答
              </span>
            </div>
            <div>
              <div style="margin-top: 12px">
                <span class="qa-date">{{qa.createdTime}}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <!--分页-->
    <div style="margin-top: 40px;text-align: center">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="this.pageInfo.pageSize"
        :current-page="this.pageInfo.pageNum"
        @current-change="handleCurrentChange"
        :total="this.pageInfo.total"
        v-if="qaArray.length > 0">
      </el-pagination>
    </div>
    <!--问答对话框-->
    <el-dialog
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :lock-scroll = false
      custom-class="comment-dialog">
      <div style="margin-top: -25px">
        <div style="margin-bottom: 22px">
          <span style=" font-size: 16px;font-weight: bold;color: #1c1f21;"> 我有疑问</span>
        </div>
        <el-input
          type="textarea"
          placeholder="请输入您的疑问..."
          v-model="qaContent"
          maxlength="300"
          show-word-limit
          rows="4"
        >
        </el-input>
        <div style="margin-top: 25px">
          <el-row style="text-align: right">
            <el-col :span="10">
              <div style="height: 1px"></div>
            </el-col>
            <el-col :span="9">
              <el-alert
                :title="alertTitle"
                type="warning"
                show-icon
                center
                :closable="false"
                style="background-color: #FFFFFF;color: #be3948;"
                :style="{visibility: isHidden? 'hidden':'visible'}">
              </el-alert>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="commit" round>提交疑问</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "QueAndAns",
    props: {
      qaArray: Array,
      pageInfo: Object,
      courseId: String
    },
    data() {
      return {
        dialogVisible: false,
        qaContent: '',
        alertTitle: '', // 警告信息
        isHidden: true, // 是否隐藏
        buttonActive: 'all',
        status: '', // 问答状态
      }
    },
    methods: {
      errorHandler() {
        return true;
      },
      handleCurrentChange(pageNum) {
        this.pageInfo.pageNum = pageNum;
        this.getPageListQA();
      },
      // 切换问答内容
      changeContent(buttonActive) {
        this.buttonActive = buttonActive;
        if (this.buttonActive === 'all') {
          // 判断是否要重置要第一页
          if (this.status == '') {
            return;
          }
          this.pageInfo.pageNum = 1;
          this.status = '';
        }else if(this.buttonActive === 'finish') {
          if (this.status == 'A') {
            return;
          }
          this.pageInfo.pageNum = 1;
          this.status = 'A';
        }
        this.getPageListQA();
      },
      getPageListQA() {
        this.$emit("getPageListQA", {
          "pageNum":this.pageInfo.pageNum,
          "pageSize":this.pageInfo.pageSize,
          "status":this.status
        });
      },
      toLogin() {
        this.$router.push({ path: '/login' });
      },
      // 去提问
      toAsk() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
        this.isHidden = true; // 隐藏警告
        this.qaContent = '';
      },
      async commit() {
        if (this.qaContent.length < 5) {
          this.alertTitle = '内容不能少于5个字符！';
          this.isHidden = false;
          return;
        }
        const {success} = await this.$http.post('/business/web/questionAnswer/create',
          {courseId:this.courseId,content:this.qaContent})
        this.isHidden = true;
        this.dialogVisible = false;
        if (success) {
          this.$message.success("问题提交成功,候等管理员审批！");
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-card__body {
    padding: 0;
  }
  .box-card {
    border-radius: 12px;
    margin-bottom: 10px;
    box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
    position: relative;
  }
  .qa {
    padding: 30px ;
    background-color:#FFFFFF;
  }
  .qa-content {
    padding-right: 20px;
    min-height: 85px;
    position: relative;
    overflow: hidden;
    word-wrap: break-word;
    word-break: break-all;
  }
  .title {
    font-size: 15px;
    color: #1c1f21;
    font-weight: 700;
  }
  .content {
    font-size: 14px;
  }
  .qa-date {
    color: #93999f;
    font-size: 14px;
    float: right;
  }
  .icon-qa {
    position: absolute;
    left: 0;
    top: 0;
    width: 48px;
    height: 48px;
    background: url("../../assets/img/icon_wenda.png") no-repeat 0 0;
    background-size: cover;
  }
  .icon-finish {
    background: url("../../assets/img/icon_finish.png") no-repeat 0 0;
    background-size: cover;
  }
</style>
